export default __webpack_public_path__ + "static/media/success-image.91e786c0.svg";